// 组合加载：all.js 为集中定义（覆盖大部分工具），各独立 .js 文件为组件级文案
import all from './all'

const ctx = require.context('.', false, /\.js$/)
const tools = { ...all }
ctx.keys().forEach(key => {
  if (key === './index.js' || key === './all.js') return
  const name = key.replace(/^\.\//, '').replace(/\.js$/, '')
  tools[name] = { ...tools[name], ...ctx(key).default }
})
export default tools
